module.exports = __webpack_public_path__ + "img/aw.fcd7c184.svg";